module.exports = __webpack_public_path__ + "img/FactsheetImage.86bbcdab.jpg";